import { z } from "zod";
import { getPartnershipParamSchema } from "./get-partnership.schema";
import { patchPartnershipNumericAgreementQuerySchema } from "./patch-partnership-numeric-agreement.schema";

const agreementTypes = [
	"early-payment-discount",
	"early-payment-discount-payment-target",
	"hourly-rate",
	"payment-target",
	"service",
] as const;

export const getPartnershipAgreementParamSchema = z
	.object({
		agreementType: z.enum(agreementTypes),
	})
	.and(getPartnershipParamSchema);

export const getPartnershipAgreementQuerySchema = z
	.object({
		date: z.string().optional(),
	})
	.and(patchPartnershipNumericAgreementQuerySchema);

export type GetPartnershipAgreementParam = z.infer<typeof getPartnershipAgreementParamSchema>;

export type GetPartnershipAgreementQuery = z.infer<typeof getPartnershipAgreementQuerySchema>;
